import { IClassroom } from 'interfaces/classrooms';
import { SupplementaryMaterialsPanel } from 'components/supplementary_materials/SupplementaryMaterialsPanel';

export interface ClassroomSupplementarMaterialProps {
  classroom: IClassroom;
}

const ClassroomSupplementarMaterial = ({
  classroom
}: ClassroomSupplementarMaterialProps) => (
  <SupplementaryMaterialsPanel
    parentKind="classroom"
    parentReference={classroom.id}
    variant="complementary"
  />
);

export default ClassroomSupplementarMaterial;
